/**
 * Assignés d’une tâche nouvellement créée.
 * Soi-même est toujours inclus (auto-assign) ; les @mentions s’ajoutent.
 */

export function withDefaultSelfAssignee(
  mentionedIds: readonly string[],
  currentCollaboratorId: string | null,
): string[] {
  const ids: string[] = [];
  const seen = new Set<string>();
  const push = (id: string) => {
    if (!id || seen.has(id)) return;
    seen.add(id);
    ids.push(id);
  };
  if (currentCollaboratorId) push(currentCollaboratorId);
  for (const id of mentionedIds) push(id);
  return ids;
}
